import { render, staticRenderFns } from "./projectStatusDialog.vue?vue&type=template&id=4e8c264c&scoped=true"
import script from "./projectStatusDialog.vue?vue&type=script&lang=js"
export * from "./projectStatusDialog.vue?vue&type=script&lang=js"
import style0 from "./projectStatusDialog.vue?vue&type=style&index=0&id=4e8c264c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8c264c",
  null
  
)

export default component.exports